define('utils/scroller',['jquery'], function ($) {
	
	// Scroller voor ads
	var Scroller = function (settings) {
		var $this = this;
		this.settings = $.extend({
			width : 300,
			height: 250,
			container : $('.advertisements'),
			
			delay : 5000,
			animation : 1000,
			
			instantStart : true,
			
			random : false
			
		}, settings);
		this.interval = false;

		this.go = function () {
			var ads = $this.settings.container.find('a');
			var i = 0;		
			this.interval = setInterval(function () {
				i = ++i % ads.length;	
				$this.settings.container.animate({
					scrollLeft : i * $this.settings.width
				}, $this.settings.animation); 
			}, $this.settings.delay);
		};

        this.stop = function() {
            clearInterval(this.interval);
        };
		
		this.init = function () {
            var self = this;
			var wrapper = this.settings.container;
			wrapper.css({
				'max-width' : $this.settings.width
			});
			
			if(this.settings.random) {
				var ads = $this.settings.container.find('a');
				var n = Math.floor(Math.random()*ads.length);
				$this.settings.container.scrollLeft(n * $this.settings.width); 
			}

            wrapper.hover(function() {
                self.stop();
            }, function() {
                self.go();
            });
			
		};
		
		this.init();
		
		// go!
		if($this.settings.instantStart) {
			this.go();
		}
	};
	
	return Scroller;
});
